import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ErrorBoundary } from './features/errors/components/ErrorBoundary.tsx';
import { router } from './setup/router/router.init.tsx';
import { store } from './setup/store/store.ts';
import { StorybookContext } from './setup/storybook-context.hook.ts';
import './styles/stub.scss';

const rootElement = document.getElementById('root')!;

const root = createRoot(rootElement);

root.render(
    <StrictMode>
        <ErrorBoundary>
            <StorybookContext.Provider value={{ isStorybook: false }}>
                <Provider store={store}>
                    <RouterProvider router={router} />
                </Provider>
            </StorybookContext.Provider>
        </ErrorBoundary>
    </StrictMode>,
);
